export enum ProviderType {
    Practicioner,
    Group,
    Facility
}
